import { render, staticRenderFns } from "./TwoFactorsAuth.vue?vue&type=template&id=b8b1949a&scoped=true"
import script from "./TwoFactorsAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorsAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorsAuth.vue?vue&type=style&index=0&id=b8b1949a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b1949a",
  null
  
)

export default component.exports